import { cpBaseUrl, DELETE, GET, omsBaseUrlApi, POST, PUT } from '@constants/generic-constants.js';
import { isCP } from '@utils/app-utils.js';
import tenantConfig from 'data/customizer/tenant-config.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import {
  ACTION_INDEX,
  ACTION_SHOW,
  PERMISSION_KEY_RETURN_POLICY,
  PERMISSION_KEY_STORE,
  PERMISSION_KEY_WAREHOUSE,
  PERMISSION_KEY_WARRANTY_TYPE,
} from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import NetworkManager from '../../services/network-service.js';
import { redirectToPath } from '../../utils/utils.js';

export const getStoreDetailApi = (params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_STORE, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    const url = `${omsBaseUrlApi}/stores/${storeId}${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateWarehouseApi = (body, id, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warehouses/${id}`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getWarehouseDetail = (id, storeId = 1) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_WAREHOUSE, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    const url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/${tenantConfig?.api?.[isCP() ? 'cp' : 'seller_center']?.warehouses?.exclude_store_on_detail ? '' : `stores/${storeId}/`}warehouses/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createWarehouseApi = (body, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warehouses`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteWarehouseApi = (id, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warehouses/${id}`;
    NetworkManager.performRequest(url, null, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateStoreApi = (id, body) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${id}`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const storeReturnPolicyListingApi = (params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_RETURN_POLICY, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    const url = `${omsBaseUrlApi}/stores/${storeId}/return_policies${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const returnPolicyDetailApi = (returnPolicyId, params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_RETURN_POLICY, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    const url = `${omsBaseUrlApi}/stores/${storeId}/return_policies/${returnPolicyId}${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addReturnPolicyApi = (returnPolicyData, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/return_policies`;
    NetworkManager.performRequest(url, returnPolicyData, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateReturnPolicyApi = (returnPolicyId, returnPolicyData, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/return_policies/${returnPolicyId}`;
    NetworkManager.performRequest(url, returnPolicyData, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteReturnPolicyApi = (returnPolicyId, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/return_policies/${returnPolicyId}`;
    NetworkManager.performRequest(url, null, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const storeWarrantyListingApi = (params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_WARRANTY_TYPE, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    const url = `${omsBaseUrlApi}/stores/${storeId}/warranty_types${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const warrantyDetailApi = (warrantyId, params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warranty_types/${warrantyId}${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addWarrantyApi = (warrantyData, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warranty_types`;
    NetworkManager.performRequest(url, warrantyData, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateWarrantyApi = (warrantyId, warrantyData, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warranty_types/${warrantyId}`;
    NetworkManager.performRequest(url, warrantyData, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteWarrantyApi = (warrantyId, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warranty_types/${warrantyId}`;
    NetworkManager.performRequest(url, null, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getWarehousesListingApi = (params = '', storeId = 1) => {
  if (!PermissionsHelper.getPermissions(PERMISSION_KEY_WAREHOUSE, ACTION_INDEX)) {
    redirectToPath(ACCESS_DENIED);
    return;
  }
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warehouses${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getWarehouseToEdit = (param, storeId = 1) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/warehouses/${param}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCurrentUserApi = () => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/users/current`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        if (error?.status === 401) {
          // if (isOLXTenant()) {
          //   resolve({ unauthorized: true });
          //   redirectToPath(STORE_NOT_FOUND);
          // } else {
          reject(error);
          // }
        } else {
          reject(error);
        }
      });
  });
};

export const dubizzleLoginApi = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/auth/login`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const dubizzleLogoutApi = () => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/auth/logout`;
    NetworkManager.performRequest(url, null, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const olxLogoutApi = (body = null) => {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_KEYCLOAK_URL}/auth/realms/olx-pk/protocol/openid-connect/logout`;
    NetworkManager.performRequest(url, body, POST, null, null, true, 'application/x-www-form-urlencoded', true, false)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const acceptTermsAndConditionsApi = (storeId) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/stores/${storeId}/accept_terms_and_conditions`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTermsAndConditionsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/terms_and_conditions${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updatePasswordApi = (data = null) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/users/update_password`;
    NetworkManager.performRequest(url, data, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
